import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\34\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './MediaCarousel.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import ScrollAnimation from 'react-animate-on-scroll';
// import LazyPicture from '../atoms/LazyPicture';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import Video from '../atoms/Video';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickData, tealiumMergeClickNewData } from '../../utils/tealium';
import { useInView } from 'react-intersection-observer';
import MediaGrid from '../28_MediaGrid/MediaGrid';
export var MediaCarousel = function MediaCarousel(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _useInView = useInView({
      rootMargin: '200px 0px 200px 0px',
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var imagesRef = React.useRef(null);
  var showAsCarousel = get(fields, 'data.items.showAsCarousel.jss.value');
  var title = get(fields, 'data.items.title');
  var description = get(fields, 'data.items.description');
  var textRef = React.useRef(null);
  var _fields$data = fields.data,
    playButtonAnalytics = _fields$data.playButtonAnalytics,
    nextPrevAnalytics = _fields$data.nextPrevAnalytics,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    mobileSlidesAnalytics = _fields$data.mobileSlidesAnalytics;
  var nextPrevAnalyticsEventLabJssValue = get(nextPrevAnalytics, 'eventLab.jss.value', get(nextPrevAnalytics, 'eventLab', ''));
  var dataItems = get(fields, 'data.items', {});
  var mediaItems = get(dataItems, 'mediaItems.targetItems', []);
  var listItems = mediaItems.length ? mediaItems : get(dataItems, 'children', []);
  React.useEffect(function () {
    if (inView) {
      var imagesRefArray = imagesRef.current.querySelectorAll('.lazy-images');
      for (var i = 0; i <= imagesRefArray.length - 1; i++) {
        imagesRefArray[i].querySelectorAll('source')[0].setAttribute('srcSet', imagesRefArray[i].querySelectorAll('source')[0].getAttribute('data-srcset'));
        imagesRefArray[i].querySelectorAll('img')[0].setAttribute('src', imagesRefArray[i].querySelectorAll('img')[0].getAttribute('data-src'));
      }
    }
  }, [inView]);
  React.useEffect(function () {
    if (showAsCarousel) {
      window.addEventListener('resize', getPadding);
    }
  }, []);
  if (!fields) {
    console.warn('MediaCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [MediaCarousel component is empty: please provide data source]");
    }
    return null;
  }
  var renderItems = function renderItems() {
    setTimeout(function () {
      return getPadding();
    }, 0);
    return listItems.map(function (item) {
      var imageSrc = get(item, 'image.jss.value.src', '');
      var imageCaption = get(item, 'caption.value', '');
      var videoSrc = get(item, 'video.jss.value.href', '');
      var videoType = get(item, 'video.jss.value.linktype', '');
      var videoName = item.name;
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        "data-cy": "media-carousel-item",
        className: "media-carousel-item"
      }, /*#__PURE__*/React.createElement("div", {
        className: "media-carousel__inner"
      }, /*#__PURE__*/React.createElement("div", {
        className: "media-wrap"
      }, imageSrc && /*#__PURE__*/React.createElement("picture", {
        className: ""
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 991px)",
        srcSet: "".concat(imageSrc, "&cx=0.5&cy=0.5&cw=940&ch=620"),
        "data-srcset": "".concat(imageSrc, "&cx=0.5&cy=0.5&cw=940&ch=620")
      }), /*#__PURE__*/React.createElement("img", {
        draggable: false,
        className: "img-max-wh ",
        src: "".concat(imageSrc, "&cx=0.5&cy=0.5&cw=940&ch=620"),
        "data-src": "".concat(imageSrc, "&cx=0.5&cy=0.5&cw=940&ch=620"),
        alt: item.image.jss.value.alt ? item.image.jss.value.alt : ""
      })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
        buttonTopAlignment: true,
        videoSrc: videoSrc,
        videoType: videoType,
        click: function click(e) {
          return tealiumClickFunc(params, "".concat(e, ": ").concat(videoName));
        },
        disableFocusableOnMount: true
      }), imageCaption && /*#__PURE__*/React.createElement("div", {
        className: 'carousel-caption-block'
      }, /*#__PURE__*/React.createElement("p", {
        className: "carousel-caption-pagination__caption"
      }, imageCaption)))));
    });
  };
  var getPadding = function getPadding() {
    if (imagesRef.current && textRef.current) {
      if (window.innerWidth > 768) {
        var imagesWrap = imagesRef.current.querySelectorAll('.media-wrap img');
        var arrWidth = [];
        imagesWrap.forEach(function (item) {
          return arrWidth.push(item.offsetWidth);
        });
        arrWidth.sort(function (a, b) {
          return b - a;
        });
        var textWidth = textRef.current.offsetWidth;
        // textRef.current.style = `padding: 0 ${(textWidth - arrWidth[0]) / 2 + 1}px`;
      } else {
        // textRef.current.style = `padding: 0`;
      }
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "m26-media-carousel"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, showAsCarousel ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "media-carousel-header"
    }, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "media-carousel-header__title",
      ref: textRef
    }, /*#__PURE__*/React.createElement("span", {
      className: "media-carousel__title-text"
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "media-carousel-header__title-text",
      field: title.jss,
      "data-cy": "media-carousel-media-title"
    }), description && /*#__PURE__*/React.createElement(RichText, {
      tag: "p",
      className: "media-carousel-header__description media-carousel-header__description--gray",
      field: description.jss,
      "data-cy": "media-carousel-media-description"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "btn-group--rtl"
    }, renderPreviousButton(function () {
      tealiumClickFunc(tealiumMergeClickNewData(_objectSpread(_objectSpread({}, nextPrevAnalytics), {}, {
        eventLab: {
          jss: {
            value: nextPrevAnalyticsEventLabJssValue.replace('Next/Previous', 'Previous')
          }
        }
      }), params));
    }), renderNextButton(function () {
      tealiumClickFunc(tealiumMergeClickNewData(_objectSpread(_objectSpread({}, nextPrevAnalytics), {}, {
        eventLab: {
          jss: {
            value: nextPrevAnalyticsEventLabJssValue.replace('Next/Previous', 'Next')
          }
        }
      }), params));
    }))), /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: "media-carousel__wrapper ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '')
    }, /*#__PURE__*/React.createElement("div", {
      ref: imagesRef,
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-8 offset-md-2"
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 768
          },
          items: 1
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData(mobileSlidesAnalytics, params));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-md-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: "carousel-caption-pagination"
    }, renderDots(function () {
      return navBubblesAnalytics ? tealiumClickFunc(tealiumMergeClickData(navBubblesAnalytics, params)) : null;
    }))))));
  }) : /*#__PURE__*/React.createElement(MediaGrid, {
    fields: {
      data: {
        item: fields.data.items
      }
    },
    params: params,
    isFromMediaCarousel: true
  }))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var commonStyles = "c1kan27s";
export var ltrStyles = "lbywgv";
export var rtlStyles = "r1k94zdp";
export default MediaCarousel;